<div class="main-container" *ngIf="ctrl === 'on'">
  <div class="outer-container">
    <div class="inner-container">
      <div class="slides">
        <div class="slide">
          This scoreboard<br/> is powered by
        </div>
        <div>
          <img alt="logo" class="ball-score-logo" src="/assets/logos/ball-score/1h105.png" />
        </div>
        <div>
          www.ballscore.app
        </div>
      </div>
    </div>
  </div>
</div>
